import { reactive, toRefs } from 'vue';
let data = reactive({
    standardSamplingInfo: [], //标准样取色信息
    dyeSamplingInfo: [], //染色样取色信息
    dyeColorDiffTable: [], //染色样色差值表格
    //===================
    illuminantIds: [],//光源
    // spectrums: [],//标准样反射率
    // dyeSpectrums: [],//染色样反射率
    products: [],//染色液配方
    fabricInfo: {},//织物信息
    blendListArr: [],//纤维选择完成后渲染的表格信息
    fabricId: undefined,//织物id
    fabricKind: undefined,//织物类型 0:真实纤维 1:虚拟纤维
    fabricName: undefined,//织物名
    equipmentId: undefined,//精明配色标识id
    equipmentName: undefined,//精明配色标识名
    codeNum: undefined,//配方代号
    formulaId: undefined,//接口返回配方ID
})
const methods = {
    init() {
        data.standardSamplingInfo = []
        data.dyeSamplingInfo = []
        data.dyeColorDiffTable = []
        data.illuminantIds = []
        data.products = []
        data.fabricId = undefined
        data.fabricName = undefined
        data.fabricInfo = {}
        data.equipmentId = undefined
        data.equipmentName = undefined
        data.codeNum = undefined
        data.formulaId = undefined
        data.productCheckedList = undefined
        data.forList = undefined
        data.bathRatioId = undefined
        data.clothKindId = undefined
        data.gramWeightId = undefined
        data.processId = undefined
        data.blendListArr = []
    }
}
export default {
    data,
    ...toRefs(data),
    ...methods,
}
